import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SelectedAccountUserGroupFragment = { __typename?: 'AccountUserGroup', id: string, emoji?: string | null, deletedAt?: string | null, name?: string | null, insertedAt?: string | null, memberCount?: number | null, projectCount?: number | null, workspaceCount?: number | null, updatedAt?: string | null, creator?: { __typename?: 'AuthenticatedUser', id: string, name?: string | null } | { __typename?: 'IdentifiedUser', id: string, name?: string | null } | null };

export const SelectedAccountUserGroup = /*#__PURE__*/ gql`
    fragment SelectedAccountUserGroup on AccountUserGroup {
  id
  emoji
  deletedAt
  name
  insertedAt
  memberCount
  projectCount
  workspaceCount
  creator {
    id
    name
  }
  updatedAt
}
    ` as unknown as DocumentNode<SelectedAccountUserGroupFragment, unknown>;

        

        
export const useSelectedAccountUserGroupFragment = (
  input: string | Omit<UseFragmentOptions<SelectedAccountUserGroupFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AccountUserGroup' } };
    return input;
  })();

  return useFragment<SelectedAccountUserGroupFragment>({
    fragment: SelectedAccountUserGroup,
    fragmentName: 'SelectedAccountUserGroup',
    ...options,
  });
};
  
        